import PageTitle from "features/navigation/pageTitle"

const NotFoundPage = () => {
    return (
        <>
            <PageTitle title="404 - Not Found" />
            <p>The page you are looking for does not exist.</p>
        </>
    );
}

export default NotFoundPage
